import React from "react"
import { useState } from "react"
import { useEffect } from "react"
import Nav from "../components/Nav"
import Footer from "../components/Footer"
import Container from "../components/core/Container"
import SectionTag from "../components/core/SectionTag"
import Entity from "../components/kurzy/Entity"
import { nabidka } from "../courses/nabidka"
import { lecturers } from "../lecturers/lecturers"
import Heading from "../components/core/Heading"
import Button from "../components/core/Button"
import { handleSubscribeUsSubmit } from "../handlers/handleSubcribeUsSubmit"
import SubscribeUs from "../components/emailing/SubscribeUs"
import SEO from "../components/SEO"
import InfoPopUp from "../components/pop_up/InfoPopUp"


export default function KurzyPage(){    
    const [isInfoPopUpOpen, setIsInfoPopUpOpen] = useState(false);
    const [infoPopUpTitle, setInfoPopUpTitle] = useState("");   
    const [infoPopUpText, setInfoPopUpText] = useState("");
    const [infoPopUpType, setInfoPopUpType] = useState("success");

    const handleSubscribeUsSubmitOverride = async (e) => {
        e.preventDefault();
        const formData = {
            email: e.target.email.value,
        }
        console.log(formData);
        try {
            const result = await handleSubscribeUsSubmit(formData);
            if (result.success) {
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("success");
            setInfoPopUpTitle("Odběr newsletteru byl úspěšně odeslán!");
            setInfoPopUpText("Odběr newsletteru byl úspěšně odeslán! Váš email bude v nejbližší době přidán do našeho newsletteru.");
            e.target.reset(); // Reset formuláře po úspěšném odběru
            } else {
                setIsInfoPopUpOpen(true);
                setInfoPopUpType("error");
                setInfoPopUpTitle("Nepodařilo se odeslat odběr newsletteru!");
                setInfoPopUpText(result.message);
            }
        } catch (error) {       
            console.error('Chyba při odběru newsletteru:', error);
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("error");
            setInfoPopUpTitle("Nepodařilo se odeslat odběr newsletteru!");
            setInfoPopUpText("Nepodařilo se odeslat odběr newsletteru. Zkuste to prosím znovu.");
        }
    }

    const [filterValues, setFilterValues] = useState({
        type: "All",
        lecturer: "All",
        search: ""
    })
    const [entities, setEntities] = useState(nabidka)

    const handleChangeFilterValues = (e) => {
        const key = e.target.name || e.target.id;
        const value = e.target.value;
        setFilterValues({
            ...filterValues,
            [key]: value
        });
    }

    useEffect(()=> {
        console.log("Změna filtrů", filterValues)
        let filteredEntities = nabidka.filter(entity => {
            // Filtrování podle typu kurzu (format)
            if (filterValues.type && filterValues.type !== "All") {
                if (entity.format !== filterValues.type) {
                    return false;
                }
            }
            
            // Filtrování podle lektora
            if (filterValues.lecturer && filterValues.lecturer !== "All") {
                if (entity.lecturer !== filterValues.lecturer) {
                    return false;
                }
            }
            
            // Filtrování podle vyhledávacího dotazu
            if (filterValues.search && filterValues.search.trim() !== "") {
                const searchTerm = filterValues.search.toLowerCase();
                const matchesName = entity.name.toLowerCase().includes(searchTerm);
                const matchesDescription = entity.description.toLowerCase().includes(searchTerm);
                if (!matchesName && !matchesDescription) {
                    return false;
                }
            }
            
            return true;
        });
        
        setEntities(filteredEntities);
    }, [filterValues])

    const handleResetFilters = () => {
        console.log("Resetuji filtry")
        setFilterValues({
            type: "All",
            lecturer: "All",
            search: ""
        })
    }


    // Strukturovaná data pro stránku kurzů
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "Nabídka kurzů - digibezstresu",
        "description": "Prohlédněte si naši kompletní nabídku vzdělávacích kurzů. Online i prezenční kurzy pro vaše vzdělávání.",
        "itemListElement": nabidka.map((course, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "@type": "Course",
                "name": course.name,
                "description": course.description,
                "provider": {
                    "@type": "EducationalOrganization",
                    "name": "digibezstresu"
                },
                "courseMode": course.format === "Online" ? "online" : "onsite",
                "location": course.location,
                "offers": {
                    "@type": "Offer",
                    "price": course.live_price,
                    "priceCurrency": "CZK"
                }
            }
        }))
    };

    return(
        <>
            <SEO
                title="Nabídka kurzů - digibezstresu"
                description="Prohlédněte si naši kompletní nabídku vzdělávacích kurzů. Online i prezenční kurzy pro vaše vzdělávání. Filtrujte podle typu kurzu nebo lektora."
                keywords="kurzy, vzdělávací kurzy, online kurzy, prezenční kurzy, školení, workshopy, vzdělávání"
                url="/kurzy"
                structuredData={structuredData}
            />
            <Container className="min-h-screen flex flex-col overflow-x-hidden">
                <Nav/>
            <Container className="w-full max-w-full flex flex-col lg:grid lg:grid-cols-[20%_80%] gap-4 mx-auto px-4 overflow-x-hidden">
                {/* Main content - SectionTag a kurzy */}
                <Container bgColor="transparent" className="min-w-0 mt-8 md:mt-12 px-4 order-1 lg:order-2">
                    <SectionTag>Naše nabídka kurzů</SectionTag>
                    
                    {/* Filter container - na mobilu pod SectionTag, na desktopu vlevo */}
                    <Container bgColor="gray-50" className="flex flex-col mt-4 mb-6 lg:hidden gap-4 rounded-lg p-4 shadow-md">
                        <Heading variant="h4" className="mb-2">Filtrování</Heading>
                        {/* Filtrování podle typu kurzu + lektorů */}
                        <Container bgColor="transparent" className="flex flex-col gap-2">
                            <label htmlFor="type" className="text-sm font-medium text-gray-700">Typ kurzu:</label>
                            <select 
                                name="type" 
                                id="type" 
                                value={filterValues.type}
                                onChange={handleChangeFilterValues}
                                className="w-full text-black bg-white border-2 border-gray-300 rounded-xl py-2 px-3 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transition-all duration-300"
                            >
                                <option value="All">Všechny typy</option>
                                <option value="Online">Online</option>
                                <option value="Prezenční">Prezenční</option>
                            </select>
                        </Container>

                        <Container bgColor="transparent" className="flex flex-col gap-2">
                            <label htmlFor="lecturer" className="text-sm font-medium text-gray-700">Lektor:</label>
                            <select 
                                name="lecturer" 
                                id="lecturer" 
                                value={filterValues.lecturer}
                                onChange={handleChangeFilterValues}
                                className="w-full text-black bg-white border-2 border-gray-300 rounded-xl py-2 px-3 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transition-all duration-300"
                            >
                                <option value="All">Všichni lektoři</option>
                                {lecturers.map((lecturer) => (
                                    <option key={lecturer.id} value={lecturer.id}>{lecturer.name} {lecturer.surname}</option>
                                ))}
                            </select>
                        </Container>

                        <Button variant="primary" size="md" className="w-full mt-2" onClick={() => handleResetFilters()}>Resetovat filtry</Button>
                    </Container>

                    {/* Search bar */}
                    <Container bgColor="transparent" className="mb-6">
                        <div className="relative">
                            <input 
                                type="text" 
                                name="search"
                                id="search"
                                value={filterValues.search}
                                placeholder="Hledat kurz..." 
                                className="w-full bg-white border-2 border-gray-300 rounded-xl py-3 px-4 pl-12 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transition-all duration-300"
                                onChange={handleChangeFilterValues}
                            />
                            <svg 
                                className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                    </Container>
      
                    {/* Kurzy */}
                    <div className="relative z-0">
                        {entities.map((entity) => (
                            <Entity key={entity.id} entity={entity} lecturer={lecturers.find(lecturer => lecturer.id === entity.lecturer)} />
                        ))}
                    </div>
                </Container>

                {/* Filter sidebar - pouze na desktopu */}
                <Container bgColor="gray-50" className="hidden lg:flex sticky top-20 h-fit flex-col mt-2 mb-2 gap-4 rounded-lg p-4 z-0 shadow-md order-2 lg:order-1">
                    <Heading variant="h4" className="mb-2">Filtrování</Heading>
                    {/* Filtrování podle typu kurzu + lektorů */}
                    <Container bgColor="transparent" className="flex flex-col gap-2">
                        <label htmlFor="type-desktop" className="text-sm font-medium text-gray-700">Typ kurzu:</label>
                        <select 
                            name="type" 
                            id="type-desktop" 
                            value={filterValues.type}
                            onChange={handleChangeFilterValues}
                            className="w-full text-black bg-white border-2 border-gray-300 rounded-xl py-2 px-3 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transition-all duration-300"
                        >
                            <option value="All">Všechny typy</option>
                            <option value="Online">Online</option>
                            <option value="Prezenční">Prezenční</option>
                        </select>
                    </Container>

                    <Container bgColor="transparent" className="flex flex-col gap-2">
                        <label htmlFor="lecturer-desktop" className="text-sm font-medium text-gray-700">Lektor:</label>
                        <select 
                            name="lecturer" 
                            id="lecturer-desktop" 
                            value={filterValues.lecturer}
                            onChange={handleChangeFilterValues}
                            className="w-full text-black bg-white border-2 border-gray-300 rounded-xl py-2 px-3 focus:border-main focus:bg-white focus:shadow-lg focus:outline-none transition-all duration-300"
                        >
                            <option value="All">Všichni lektoři</option>
                            {lecturers.map((lecturer) => (
                                <option key={lecturer.id} value={lecturer.id}>{lecturer.name} {lecturer.surname}</option>
                            ))}
                        </select>
                    </Container>

                    <Button variant="primary" size="md" className="w-full mt-2" onClick={() => handleResetFilters()}>Resetovat filtry</Button>
                </Container>
            </Container>
            <SubscribeUs onSubmit={handleSubscribeUsSubmitOverride}/>
            {isInfoPopUpOpen && <InfoPopUp title={infoPopUpTitle} text={infoPopUpText} type={infoPopUpType} onClick={() => setIsInfoPopUpOpen(false)}/>}
            <Footer/>
        </Container>
        </>
    )
}